/* eslint-disable react/button-has-type */
import React from 'react';
// import nextBlackIcon from '../../assets/svg/nextBlack.svg';
// import prevWhiteIcon from '../../assets/svg/prevWhite.svg';
import nextWhiteIcon from '../../assets/svg/nextWhite.svg';
import prevBlackIcon from '../../assets/svg/prevBlack.svg';

const SliderButton = ({ onClick, size = 24, isNext }) => (
  <button
    onClick={onClick}
    style={{
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: isNext ? '#1E3A4C' : 'transparent',
      border: isNext ? 'none' : '1px solid #1E3A4C',
      borderRadius: size > 24 ? '2px' : '4px',
      cursor: 'pointer',
    }}
    >
    <img src={isNext ? nextWhiteIcon : prevBlackIcon} alt="arrow" style={{ width: '50%', height: '50%' }} />
  </button>
);

export default SliderButton;
